import { cva } from 'class-variance-authority';

/** 4×4 grid container for years. */
export const yearGridContainerClasses = 'tw:flex tw:flex-col';

/** 4×4 grid for year cells. */
export const yearGridClasses =
  'tw:grid tw:grid-cols-4 tw:gap-[var(--spacing-micro)] tw:p-[var(--spacing-small)]';

/** Individual year cell button (CVA with state variants). */
export const yearCellClasses = cva(
  [
    'tw:flex tw:items-center tw:justify-center',
    'tw:py-[var(--spacing-small)] tw:px-[var(--spacing-micro)]',
    'tw:rounded-[var(--radius-8)]',
    'tw:text-12 tw:font-regular',
    'tw:transition-colors tw:duration-150',
    'tw:border-0 tw:p-0',
    'tw:cursor-pointer',
    'tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-primary tw:focus-visible:ring-inset',
  ].join(' '),
  {
    variants: {
      state: {
        default: 'tw:text-font tw:bg-white tw:hover:bg-gray-lighter',
        selected: 'tw:bg-primary tw:text-white tw:font-semibold',
        current: 'tw:text-accent tw:font-semibold tw:bg-white tw:hover:bg-gray-lighter',
        disabled: 'tw:text-gray tw:opacity-50 tw:cursor-not-allowed',
      },
    },
    defaultVariants: {
      state: 'default',
    },
  }
);

/** Footer row for year pagination arrows. */
export const yearNavClasses =
  'tw:flex tw:items-center tw:justify-between tw:px-[var(--spacing-base)] tw:py-[var(--spacing-small)] tw:border-t tw:border-solid tw:border-gray-light';

/** Year navigation button (prev/next page). */
export const yearNavButtonClasses =
  'tw:inline-flex tw:items-center tw:justify-center tw:rounded-[var(--radius-8)] tw:border tw:border-solid tw:border-gray tw:bg-white tw:p-[var(--spacing-micro)] tw:shadow-sm tw:cursor-pointer tw:transition-colors tw:hover:bg-gray-lighter tw:focus:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-primary tw:text-font';
